import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'

// Actions
import { getInsuranceCompany, CreateSaveInsuranceCompany } from '../../../actions/insurancecompanies'
import { setLanguage, getLanguageInfos } from '../../../language/actions'

// Components
// import HelpText from '../../../shared/components/HelpText'

// contants
import { CarRentalSystemTypes } from '../../../constants'

// Elements
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Text from '../../../shared/elements/text'
import Switch from '../../../shared/elements/switch'
import TextArea from '../../../shared/elements/textarea'
import DropDown from '../../../shared/elements/dropDown'

// Utils
import { hasAccess } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

// Styles
import './view.scss'

class View extends Component {
  constructor (props) {
    super(props)
    this.state = {
      type: 'create',
      insuranceCompany: {
        InsuranceCompanyId: 0,
        Code: '',
        Name: '',
        Company: '',
        Active: '',
        Comment: '',
        Debtor: '',
        contractTypeSelected: 0,
        RentLogContractTypeInfo: null,
        ContractTypeListFromRentLog: []
      }
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.onInputLanguageChange = this.onInputLanguageChange.bind(this)
    this.onRadioChange = this.onRadioChange.bind(this)
    this.saveAddInsuranceCompany = this.saveAddInsuranceCompany.bind(this)
    this.addInsuranceCompany = this.addInsuranceCompany.bind(this)
  }

  componentDidMount () {
    this.getInsuranceCompany(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.item.InsuranceCompanyId !== nextProps.item.InsuranceCompanyId) {
      this.getInsuranceCompany(nextProps)
    }
  }

  getInsuranceCompany (props) {
    // console.log('getInsuranceCompany props', props)
    if (typeof props.item === 'undefined') return
    if (typeof props.item.InsuranceCompanyId !== 'undefined') {
      props.getInsuranceCompany(props.item.InsuranceCompanyId).then((res) => {
        this.setState({
          type: 'edit',
          insuranceCompany: res.data
        })
      }, () => {
        window.toastr.error(translation('910'), translation('216'))
      })
    } else {
      this.resetCreate()
    }
  }

  resetCreate () {
    this.setState({
      type: 'create',
      insuranceCompany: {
        InsuranceCompanyId: 0,
        Code: '',
        Name: '',
        Company: '',
        Active: true,
        Comment: '',
        Debtor: '',
        contractTypeSelected: 0,
        RentLogContractTypeInfo: null,
        ContractTypeListFromRentLog: []
      }
    })
  }

  saveAddInsuranceCompany (e) {
    if (this.state.insuranceCompany.InsuranceCompanyId > 0) {
      let insuranceCompany = { ...this.state.insuranceCompany }
      // update
      this.props.CreateSaveInsuranceCompany(insuranceCompany).then((res) => {
        this.props.onSave(res.data, this.state.type)
        this.setState({
          insuranceCompany: res.data
        })
      }, (err) => {
        if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
          let errors = err.response.data.Errors
          let errorText = ''
          errors.map((item) => {
            if (item.DictionaryKey !== 0) {
              errorText += '<br />' + translation(item.DictionaryKey)
            }
          })
          // Toastr
          window.toastr.error(translation(errorText), translation('216'))
        } else {
          // Toastr
          window.toastr.error(translation('910'), translation('216'))
        }
      })
      // } else {
      //   console.log('validation error')
      // }
    }
  }

  addInsuranceCompany () {
    if (this.state.insuranceCompany.InsuranceCompanyId === 0) {
      let insuranceCompany = { ...this.state.insuranceCompany }
      // update
      this.props.CreateSaveInsuranceCompany(insuranceCompany).then((res) => {
        this.props.onSave(res.data, this.state.type)
        this.setState({
          insuranceCompany: res.data
        })
      }, (err) => {
        if (err.response.data !== undefined && err.response.data.Errors !== undefined) {
          let errors = err.response.data.Errors
          let errorText = ''
          errors.map((item) => {
            if (item.DictionaryKey !== 0) {
              errorText += '<br />' + translation(item.DictionaryKey)
            }
          })
          // Toastr
          window.toastr.error(translation(errorText), translation('216'))
        } else {
          // Toastr
          window.toastr.error(translation('1883'), translation('216'))
        }
      })
      // } else {
      //   console.log('validation error')
      // }
    }
  }

  onInputChange (name, e) {
    // console.log('this.state', this.state)
    let value = ''
    if (moment.isMoment(e)) {
      value = e
    } else {
      if (typeof e === 'undefined') {
        e = name
      }
      name = e.target.name
      value = e.target.value
    }

    if (name === 'contractTypeSelected') {
      if (value === 0) return
      name = 'RentLogContractTypeInfo'
      let newRentLogContractInfo = {
        InsuranceCompanyId: this.state.insuranceCompany.InsuranceCompanyId,
        RentLogContractTypeOid: value,
        CompanyId: this.props.auth.user.ShopId
      }
      value = newRentLogContractInfo
    }

    this.setState({
      insuranceCompany: {
        ...this.state.insuranceCompany,
        [name]: value
      }
    }, () => {
      if (name === 'StartScreen' || name === 'RentLogContractTypeInfo') {
        this.saveAddInsuranceCompany()
      }
    })
  }

  onInputLanguageChange (name, e) {
    let value = ''
    if (moment.isMoment(e)) {
      value = e
    } else {
      if (typeof e === 'undefined') {
        e = name
      }
      name = e.target.name
    }

    let langInfos = this.props.getLanguageInfos()
    langInfos.map((l) => {
      if (l.SelfLangName === e.target.value) {
        value = l.LanguageName
      }
    })

    if (this.state.insuranceCompany.InsuranceCompanyId === this.props.auth.InsuranceCompanyId) {
      this.props.setLanguage(value)
    }

    this.setState({
      insuranceCompany: {
        ...this.state.insuranceCompany,
        [name]: value
      }
    }, () => {
      if (name === 'Language') {
        this.saveAddInsuranceCompany()
      }
    })
  }
  onRadioChange (e) {
    e.persist()
    let value = e.target.value
    let name = e.target.name
    // console.log(name + '' + value)
    // console.log(e.target.name)
    if (name === 'Active') {
      value = e.target.checked
      this.setState({
        insuranceCompany: {
          ...this.state.insuranceCompany,
          Active: value
        }
      }, () => {
        this.saveAddInsuranceCompany()
      })
    } else {
      this.setState({
        insuranceCompany: {
          ...this.state.insuranceCompany,
          [name]: value
        }
      }, () => {
        this.saveAddInsuranceCompany()
      })
    }
  }

  renderInsuranceCompany () {
    let insuranceCompany = { ...this.state.insuranceCompany }
    /* const ActiveChecked = (type, active) => {
      if (active === type) {
        return (
          true
        )
      }
    } */
    const usedRentLog = this.props.auth.carRentalSystem === CarRentalSystemTypes.RENTLOG
    let contractTypeListFromRentLog = []
    if (!insuranceCompany.RentLogContractTypeInfo) contractTypeListFromRentLog.push({ Oid: 0, Name: translation('890') })

    insuranceCompany.ContractTypeListFromRentLog && insuranceCompany.ContractTypeListFromRentLog.map((val) => {
      contractTypeListFromRentLog.push({ Oid: val.Oid, Name: val.Name })
    })

    if (insuranceCompany.RentLogContractTypeInfo && contractTypeListFromRentLog.length > 1) { contractTypeListFromRentLog.filter(x => x.Oid !== 0) }

    let contractTypeSelected
    insuranceCompany.ContractTypeListFromRentLog && insuranceCompany.ContractTypeListFromRentLog.map((val) => {
      if (insuranceCompany.RentLogContractTypeInfo && insuranceCompany.RentLogContractTypeInfo.RentLogContractTypeOid === val.Oid) contractTypeSelected = val.Oid
    })
    const contractTypeOptions = contractTypeListFromRentLog.map((b, index) => {
      return <option key={index} value={b.Oid}>{b.Name}</option>
    })

    return (
      <Panel title={translation('418')}>
        <Text name='Code' value={insuranceCompany.Code || ''} disabled={!hasAccess([2], this.props.auth.user.UserType)} onChange={this.onInputChange} onBlur={this.saveAddInsuranceCompany} labelText={translation('13372')} />
        <Text name='Company' value={insuranceCompany.Company || ''} disabled={!hasAccess([2], this.props.auth.user.UserType)} onChange={this.onInputChange} onBlur={this.saveAddInsuranceCompany} labelText={translation('418')} />
        <Text name='Name' value={insuranceCompany.Name || ''} disabled={!hasAccess([2], this.props.auth.user.UserType)} onChange={this.onInputChange} onBlur={this.saveAddInsuranceCompany} labelText={translation('14800')} />
        {!hasAccess([2], this.props.auth.user.UserType) && (
          <Text name='Debtor' value={insuranceCompany.Debtor || ''} onChange={this.onInputChange} onBlur={this.saveAddInsuranceCompany} labelText={translation('13452')} />
        )}
        <TextArea name='Comment' onChange={this.onInputChange} onBlur={this.saveAddInsuranceCompany} value={insuranceCompany.Comment || ''} placeholder={translation('14801')} labelText={translation('149')} />
        {usedRentLog && <DropDown name='contractTypeSelected' value={contractTypeSelected} onChange={this.onInputChange} labelText={translation('18130')} >
          {contractTypeOptions}
        </DropDown>}
        {hasAccess([2], this.props.auth.user.UserType) && (
          <Switch name='Active' value='true' disabled={!hasAccess([2], this.props.auth.user.UserType)} checked={this.state.insuranceCompany.Active === true} onChange={this.onRadioChange} labelText={translation('295')} />
        )}
      </Panel>
    )
  }

  render () {
    // let classNameList = (this.state.type === 'edit') ? 'view_edit' : 'view_create'
    return (
      <Col>
        {this.renderInsuranceCompany()}
      </Col>
    )
  }

}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  setLanguage,
  getLanguageInfos,
  getInsuranceCompany,
  CreateSaveInsuranceCompany
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/InsuranceCompanyList/View/index.js